'use client';
import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { Box } from './Box.js';
import { panelStyles } from './Panel.js';

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const StyledContent = styled(PopoverPrimitive.Content, panelStyles, {
    minWidth: 200,
    minHeight: '$6',
    maxWidth: 265,
    '&:focus': {
        outline: 'none',
    },
});
const PopoverContent = React.forwardRef((_a, fowardedRef) => {
    var { children, hideArrow } = _a, props = __rest(_a, ["children", "hideArrow"]);
    return (React.createElement(PopoverPrimitive.Portal, null,
        React.createElement(StyledContent, Object.assign({ sideOffset: 0 }, props, { ref: fowardedRef }),
            children,
            !hideArrow && (React.createElement(Box, { css: { color: '$panel' } },
                React.createElement(PopoverPrimitive.Arrow, { width: 11, height: 5, style: { fill: 'currentColor' } }))))));
});
const PopoverClose = PopoverPrimitive.Close;

export { Popover, PopoverClose, PopoverContent, PopoverTrigger };
